<template>
  <div class="py-2 bg-base-200 w-full focus-within:bg-base-300 flex flex-row items-center justify-center">
    <select v-model="value1" @change="handleEnter" class="mx-3 w-full bg-base-200 focus:outline-none focus:bg-base-300 focus-visible:outline-none" v-if="header.type === 'lookup'">
      <option :value="null">Бүгд</option>
      <option v-for="item in rows" :key="item.id" :value="item.id">{{ item.name }}</option>
    </select>
    <input
      v-else-if="header.type === 'Boolean'"
      type="checkbox"
      class="checkbox"
      :checked="value1"
      @input="handleInputBoolean"
      :indeterminate="value1 === null"
    />
    <input
      class="mx-3 w-full flex-1 bg-base-200 focus:outline-none focus:bg-base-300 focus-visible:outline-none"
      v-else
      v-model="value1"
      type="text"
      @keydown.enter="handleEnter"
      :placeholder="placeholder"
    >
    <transition>
      <div v-show="value1 && header.type !== 'Boolean'" class="pr-3 flex items-center justify-center cursor-pointer" @click="handleClear">
        <hero-icon name="x-circle" />
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  props: {
    modelValue: { type: [String, Boolean, Number], default: null },
    placeholder: { type: String },
    header: { type: Object, default: () => { return {} } }
  },
  data () {
    return {
      loading: false,
      rows: []
    }
  },
  computed: {
    value1: {
      get () {
        return this.modelValue || null
      },
      set (val) {
        console.log('val', val)
        this.$emit('update:modelValue', val)
      }
    }
  },
  created () {
    if (this.header.type === 'lookup') {
      this.getList()
    }
  },
  methods: {
    handleClear () {
      this.value1 = ''
      this.handleEnter()
    },
    handleChange () {
      this.$emit('change', this.value1)
    },
    handleInputBoolean ($event) {
      if (this.value1 === null) {
        this.value1 = $event.target.checked
      } else if (this.value1) {
        this.value1 = false
      } else {
        this.value1 = null
      }
      this.$emit('enter', this.value1)
    },
    handleEnter () {
      this.$emit('enter', this.value1)
    },
    getList () {
      this.loading = true
      this.axios.get(`lookups/${this.header.tableName}`).then(c => {
        this.rows = c.data
      }).catch(this.handleError).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
